import Hasher from '../../../encrypt/Hasher';

export default {
    authenticated: Hasher.getItem('auth') || false,
    token: Hasher.getItem("accessToken") || "",
    user: Hasher.getItem('user') ? Hasher.getItem('user') : {},
    hashids: null,
    encrypt_key: 'fdasiioweojl43582349'
};